import { render } from "./FolderInfoPopUp.vue?vue&type=template&id=4c365a04&scoped=true&ts=true"
import script from "./FolderInfoPopUp.vue?vue&type=script&lang=ts"
export * from "./FolderInfoPopUp.vue?vue&type=script&lang=ts"

import "./FolderInfoPopUp.vue?vue&type=style&index=0&id=4c365a04&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c365a04"]])

export default __exports__